module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AMdDAADr1DsbgAAAP1JREFUOMvdk71KQ0EQhc8slsHGYOXumb2jCFoY7AWr3DqFCCJYpxMLbSxUfBXfQHwBfQQFEUS5PoS/2bW5QS2CW2e6gfnOYf6A6Y7Kxx0LrMe5kYsVdet3jZsERx9rkXyRBe8tvALIQxZ0C5x124LmiuyPYaO+Rerpv3AMsd/Cmy28ZNSk1LMCZw5auAYAU64b9TVS9ycxf2YgTvYgaPKnXAMARnkXwEhyuioSCL3VQQIaN4M7AHh8aQ4kpyMRd28MvfL1US8t6FNc0FkAMB+OjfwwhrVikej1xoI+z1fe/YhoMnK56A46nNvIwG3ny5207ZxLSkNkHE7Zv3wDP0BEJhOixVsAAAAASUVORK5CYII="


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/arrowleftdouble.png
 ** module id = 247
 ** module chunks = 0 1
 **/